import { gql } from "@apollo/client";

export const InstalledBaseNodeAttributeName = gql`
    query InstalledBaseNodeAttributeName ($id: ID!) {
        installedBaseNodePropertyDefinition (id: $id) {
            id
            preferredName
        }
    }
`;
